export const CAPTAIN_BONUSES_LIST = "CAPTAIN_BONUSES_LIST";
export const CAPTAIN_BONUSES_CREATE = "CAPTAIN_BONUSES_CREATE";
export const CAPTAIN_BONUSES_UPDATE = "CAPTAIN_BONUSES_UPDATE";
export const CAPTAIN_BONUSES_DELETE = "CAPTAIN_BONUSES_DELETE";
export const CAPTAIN_BONUSES_SHOW = "CAPTAIN_BONUSES_SHOW";
export const CAPTAIN_BONUSES_TYPE_LIST = "CAPTAIN_BONUSES_TYPE_LIST";
export const CAPTAIN_BONUSES_UPDATE_STATUS = "CAPTAIN_BONUSES_UPDATE_STATUS";
export const CAPTAIN_BONUSES_LOGS_LIST = "CAPTAIN_BONUSES_LOGS_LIST";
export const CAPTAIN_BONUSES_OWNER_TYPE_LIST = "CAPTAIN_BONUSES_OWNER_TYPE_LIST";
